import { apiClient, ApiName } from '@shared/services/api'
import { handleGlobalError } from '@shared/services/errorHandler'

class searchNatureDocsByBacenCode {
  async searchBacenCode(searchTerm) {
    try {
      const response = await apiClient.get(ApiName.ADMINS, 'operations/pre/bacen-search', {
        natureCode: searchTerm
      })
      return response.data.payload
    } catch (e) {
      handleGlobalError(e)
      throw e
    }
  }
}

export default new searchNatureDocsByBacenCode()
